module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "data-key": _vm.number,
      "viewBox": "0 -200 1000 300",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('rect', {
    attrs: {
      "data-key": _vm.number,
      "x": "0",
      "y": "0",
      "widt": "200",
      "height": "200",
      "fill": "white"
    }
  }), _vm._v(" "), _c('text', {
    staticClass: "area-title",
    attrs: {
      "data-key": _vm.number,
      "fill": "#fff",
      "font-size": "180",
      "x": "50%",
      "y": "-30%",
      "text-anchor": "middle"
    }
  }, [_vm._v("\n    A" + _vm._s(_vm.number + 1) + "\n  ")]), _vm._v(" "), _c('text', {
    staticClass: "area-title",
    attrs: {
      "data-key": _vm.number,
      "fill": "#fff",
      "font-size": "110",
      "y": "10%",
      "x": "50%",
      "text-anchor": "middle"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.areaName)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cc473dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DraggableArea.vue
// module id = 837
// module chunks = 1